import { ZOOM_TRANSCRIPT_STATUS } from "~/providers/constants/zoomTranscriptStatus";
import { ConsultationReimbursementReport } from "~/providers/utils/types/consultation";

export const hasFinalNote = (report: ConsultationReimbursementReport) =>
  Boolean(report.data?.final_note?.trim());

export const isZoomFormPending = (report: ConsultationReimbursementReport) => {
  if (report.zoom_transcript_status === ZOOM_TRANSCRIPT_STATUS.failed) {
    return false;
  }

  return (
    report.zoom_transcript_status === ZOOM_TRANSCRIPT_STATUS.in_progress ||
    (report.zoom_transcript_status === ZOOM_TRANSCRIPT_STATUS.completed &&
      !hasFinalNote(report))
  );
};

export const showZoomMeetingForm = (report: ConsultationReimbursementReport) =>
  !hasFinalNote(report);
